import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios';
import Vuex from 'vuex'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(Vuex);
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'
import common from './plugins/common'
import './plugins/string.help'
// import './assets/css/style.css'
import 'font-awesome/css/font-awesome.min.css'
import {post,post2,fetch,patch,put,upload,upload2,fetch2} from './api/request.js';
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
Vue.use(common)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$post = post
Vue.prototype.$post2 = post2
Vue.prototype.$fetch = fetch
Vue.prototype.$fetch2= fetch2
Vue.prototype.$patch = patch
Vue.prototype.$put = put
Vue.prototype.$upload = upload
Vue.prototype.$upload2 = upload2
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js